import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import get from "lodash/get";

const GET_EXPERIMENT = gql`
	query webGetExperiment($experimentName: String!) {
		session {
			experiment(name: $experimentName) {
				group
			}
		}
	}
`;

/**
 * Get the value of an experiment check.
 * @param {string} experimentName - the gatekeeper you'd like to check.
 * @param {object} [options] - useQuery options.
 * @returns {[[boolean], Object]} [experiment group name, useQuery response]
 */
function useExperiment(experimentName, options = {}) {
	// Fetch the Gatekeeper Check value from gql.
	const res = useQuery(GET_EXPERIMENT, { variables: { experimentName }, ...options });
	const experimentGroup = get(res, "data.session.experiment.group");

	// Memoized so the array doesn't change unless the contents change.
	return useMemo(() => [experimentGroup, res], [experimentGroup, res]);
}

export default useExperiment;



// WEBPACK FOOTER //
// ./src/shared/hooks/useExperiment.js